document.addEventListener('DOMContentLoaded', function() {
    setupPostMessageListener();
        // If prodId is present, update the iframe to include it
});

function getUrlParameter(name) {
    const url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return results[2];
  }

function setupPostMessageListener() {

    const customizeId = getUrlParameter('customize_id');

    if(customizeId){
      // Wait a bit for iframe to be in DOM
      const updateIframeSrc = () => {
        const iframe = document.getElementById('hot-tub-iframe');
        if (iframe) {
          const src = iframe.getAttribute('data-base-url') || iframe.getAttribute('src');
          
          // Check if customize_id is not already present
          if (!src.includes('customize_id=')) {
            const separator = src.includes('?') ? '&' : '?';
            const newSrc = src + separator + 'customize_id=' + customizeId;
            console.log('Setting iframe src with customize_id:', newSrc);
            iframe.setAttribute('src', newSrc);
          }
        } else {
          console.error('hot-tub-iframe not found in DOM');
        }
      };

      // Try immediately
      updateIframeSrc();
      
      // Also try after a short delay as fallback
      setTimeout(updateIframeSrc, 100);

    }
    
    window.addEventListener('message', async function(event) {

      // Check if message type is ADD_TO_CART
      if (event.data && event.data.type === 'ADD_TO_CART') {
        let customizationData = event.data.configuration_data || {};
        let imageUrl = event.data.screenshot_url || '';
        // let modalName = customizationData.Modell
        // let modelType = customizationData.Ofenart
        // if(modelType === "Integrierter Holzofen"){
        //   if(modalName === "Rund"){
        //     imageUrl = "https://cdn.shopify.com/s/files/1/0562/4971/2797/files/hottubmitintegriertemHolzofen_41ca1907-e732-43f3-bc14-ff14e3b52642.png?v=1718613295"
        //   } else if(modalName == "Quadratisch"){
        //     imageUrl = "https://cdn.shopify.com/s/files/1/0562/4971/2797/files/internal_thermowood_preview.jpg?v=1717771215"
        //   } else if(modalName === "Quadratisch mit Liegeplatz"){
        //     imageUrl = "https://cdn.shopify.com/s/files/1/0562/4971/2797/files/front.png?v=1718346182"
        //   }
        // }

        // if(modelType === "Externer Holzofen"){
        //   if(modalName === "Rund"){
        //     imageUrl = "https://cdn.shopify.com/s/files/1/0562/4971/2797/files/hottubmitexternemHolzofen.png?v=1718960204"
        //   } else if(modalName == "Quadratisch"){
        //     imageUrl = "https://cdn.shopify.com/s/files/1/0562/4971/2797/files/external_thermowood_preview.jpg?v=1719232409"
        //   }
        // }
        // Save configuration data first
        let saveCustomizationData = event.data.save_data? event.data.save_data : null;
        if(saveCustomizationData){
          let totalPrice = saveCustomizationData?.totalPrice || 0;
          const prodId = getUrlParameter('variantId');
          if(customizeId && prodId) {
             // Update configuration data with new customization
             await updateConfigurationData(customizeId, saveCustomizationData, totalPrice);
             
             // Instead of updating variant, create new product with updated price
             properties = await extractCartProperties(customizationData);
             properties["_customizeId"] = customizeId;
             
             const productTitle = 'Hottub Konfigurator';
             const productPrice = totalPrice; // Use the total price from customization
             
             // Remove old cart item first
             const cartId = await getUrlParameter('itemId');
             if (cartId) {
               await removeCartItem(cartId);
             }
             
             // Create new product and add to cart
             await productCreatApi(productTitle, productPrice, properties, imageUrl);
             return true;
          } else {
            let customizeId = await saveConfigurationData(totalPrice, saveCustomizationData);
            properties = await extractCartProperties(customizationData);
            properties["_customizeId"] = customizeId; // Ensure customize_id is set
            const productTitle = 'Hottub Konfigurator';
            const productPrice = customizationData.totalPrice || 100.00;
            await createProductFromIframe(productTitle, productPrice, properties, imageUrl);
          }
        }

        // Extract properties for cart
        
        
      }

    });
  }


  async function productCreatApi(title,price, properties,imageUrl) {
    const apiUrl = 'https://sauna-backend.vitkonwood.de/api/shopify/products';
    
    const payload = {
      title: title,
      price: price,
      imageUrl:imageUrl,
    };

    return fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      
      // Add product to cart after creation
      if (data && data.variants[0].id) {
        return addToCart(data.variants[0].id, 1, properties); // Add 1 quantity to cart with properties
      } else {
        throw new Error('Product ID not found in response');
      }
    })
    .then(cartData => {
      
      // Redirect to cart page
      window.location.href = '/cart';
      
      return cartData;
    })
    .catch(error => {
      console.error('Error creating product:', error);
      throw error;
    });
  }

  async function addToCart(productId, quantity = 1, properties = {}) {
    const cartData = {
      id: productId,
      quantity: quantity,
      properties: properties
    };

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add to cart: ' + response.statusText);
      }
      return response.json();
    })
    .then(cartResponse => {
      
      // Send success message to iframe
      sendMessageToIframe({
        type: 'CART_SUCCESS',
        message: 'Product added to cart successfully'
      });
      
      return cartResponse;
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      
      // Send error message to iframe
      sendMessageToIframe({
        type: 'CART_ERROR',
        message: 'Failed to add product to cart',
        error: error.message
      });
      
      throw error;
    });
  }

function extractCartProperties(customizationData) {
  const properties = {};
  
  // Iterate through all customization options
  Object.keys(customizationData).forEach(key => {
    const value = customizationData[key];
    
    // Skip totalPrice and null/undefined values
    if (key !== 'totalPrice' && value !== null && value !== undefined) {
      // If value is a string, use it directly
      if (typeof value === 'string') {
        properties[key] = value;
      }
      // If value is an object with name or optionName, extract that
      else if (typeof value === 'object') {
        if (value.name) {
          properties[key] = value.name;
        } else if (value.optionName) {
          properties[key] = value.optionName;
        }
      }
    }
  });
  
  return properties;
}

async function saveConfigurationData(totalPrice, configurationData) {
    const apiUrl = 'https://api.hot-tub.vitkonwood.de/saved-configurations';
    
    const payload = {
      totalPrice: totalPrice,
      configurationData: configurationData
    };

    let response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })

    let data = await response.json();
    let customizeId = data.id; // Assuming the API returns the saved configuration ID
    return customizeId;
    
  }


  async function updateConfigurationData(customizeId,customizationData, totalPrice) {
    const apiUrl = `https://api.hot-tub.vitkonwood.de/saved-configurations/${customizeId}`;
    const payload = {
      totalPrice: totalPrice,
      configurationData: customizationData
    };
    return fetch(apiUrl, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      // Optionally send success message to iframe
    })
    .catch(error => {
      console.error('Error updating configuration:', error);
      // Optionally send error message to iframe
      throw error;
    });
  }

  function createProductFromIframe(title, price, properties, imageUrl) {
    productCreatApi(title, price, properties, imageUrl)
      .then(result => {
        // Note: No alert here since it's triggered from iframe
      })
      .catch(error => {
        console.error('Failed to create product from iframe:', error);
        // Could send error message back to iframe if needed
      });
  }

  async function removeCartItem(cartId) {
    const currentCart = await fetch('/cart.js').then(r => r.json());

    let variantId;

    // Check if cartId is a variant ID (large number) and find the item to remove
    if (cartId > 1000) { // Assume variant IDs are large numbers
      const foundItem = currentCart.items.find(item => item.variant_id == cartId);
      if (!foundItem) {
        return;
      }
      variantId = foundItem.variant_id;
    } else {
      // cartId is a line number, get the variant ID from that line
      const lineNumber = parseInt(cartId, 10);

      if (isNaN(lineNumber) || lineNumber < 1 || lineNumber > currentCart.items.length) {
        throw new Error(`Invalid line number: ${lineNumber}. Cart has ${currentCart.items.length} items.`);
      }

      variantId = currentCart.items[lineNumber - 1].variant_id;
    }

    // Remove item by setting quantity to 0
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: { [variantId]: 0 } })
    });

    if (!response.ok) {
      throw new Error(`Failed to remove cart item: HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }

  function sendMessageToIframe(message) {
    const iframe = document.getElementById('hot-tub-iframe');
    if (iframe && iframe.contentWindow) {
      try {
        iframe.contentWindow.postMessage(message, 'https://d165s2g4q8m6he.cloudfront.net/');
        window.location.href = '/cart';
      } catch (error) {
        console.error('Error sending message to iframe:', error);
      }
    }
  }